<template>
  <v-dialog
    v-model="$store.state.more.active"
    v-if="$store.state.more.active"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title
          >Номер заказа &nbsp;&nbsp;&nbsp;<v-chip label>{{
            $store.state.more.data._id
          }}</v-chip></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn dark @click="closeDialog" depressed>
          Закрыть
          <v-icon right>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="container about">
        <div class="left">
          <v-text-field
            outlined
            readonly
            label="Дата оформление"
            :hide-details="true"
            :value="getTime($store.state.more.data.date)"
          ></v-text-field>
          <v-text-field
            outlined
            readonly
            label="Имя"
            :hide-details="true"
            :value="$store.state.more.data.name"
          ></v-text-field>
          <v-text-field
            outlined
            readonly
            label="Телефон"
            :hide-details="true"
            :value="$store.state.more.data.phone"
          ></v-text-field>

          <v-divider></v-divider>
          <v-text-field
            outlined
            readonly
            label="Дата и время бронирования"
            :hide-details="true"
            :value="
              $store.state.more.data.date_booking +
              ', ' +
              $store.state.more.data.time_booking
            "
          ></v-text-field>

          <v-text-field
            outlined
            readonly
            label="Программа"
            :hide-details="true"
            :value="
              $store.state.more.data.program +
              ' → ' +
              $store.state.more.data.subprogram
            "
          ></v-text-field>

          <v-text-field
            outlined
            readonly
            label="Опция"
            :hide-details="true"
            :value="
              $store.state.more.data.option.length > 3
                ? $store.state.more.data.option
                : $store.state.more.data.option + 'мин.'
            "
          ></v-text-field>

          <v-text-field
            outlined
            readonly
            label="Цена"
            :hide-details="true"
            :value="$store.state.more.data.price + 'руб.'"
          ></v-text-field>

          <v-text-field
            outlined
            readonly
            label="Статус платежа"
            :value="
              $store.state.more.data.paid == 'true' ? 'Оплачено' : 'Не оплачено'
            "
          >
            <v-btn
              slot="append"
              @click="getReceipt"
              small
              depressed
              dark
              v-if="$store.state.more.data.paid == 'true'"
            >
              <v-icon left>mdi-reload</v-icon> Загрузить чек
            </v-btn>
          </v-text-field>
        </div>
        <div class="right" v-if="receipt.id">
          <div class="wrap" id="receipt">
            <div class="head">
              <div>
                <h3>Квитанция платежа</h3>
                <p>Платеж прошел успешно</p>
              </div>
              <div class="download">
                <v-btn depressed text dark small @click="downloadReceipt"
                  ><v-icon left>mdi-download</v-icon> Скачать</v-btn
                >
              </div>
            </div>
            <div class="body">
              <ul>
                <li>
                  <span>Услуга</span
                  ><span>{{ $store.state.more.data.program }}</span>
                </li>
                <li>
                  <span>Подуслуга</span
                  ><span>{{ $store.state.more.data.subprogram }}</span>
                </li>
                <li>
                  <span>Метод оплаты</span
                  ><span>{{ this.receipt.payment_method.card.card_type }}</span>
                </li>
                <li>
                  <span>Последние цифры карты</span
                  ><span>* {{ this.receipt.payment_method.card.last4 }}</span>
                </li>
              </ul>
            </div>
            <div class="footer">
              <div class="total">
                Итого: <span>{{ $store.state.more.data.price + "руб." }}</span>
              </div>

              <p>© Plumeriaspa {{ new Date().getFullYear() }}</p>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

import html2canvas from "html2canvas";

export default {
  data: () => ({
    receipt: "",
  }),
  created() {},
  methods: {
    getTime(time) {
      return dayjs(parseInt(time)).format("YYYY-MM-DD/HH:mm");
    },
    loadReceipt() {
      console.log("Загрузка квитанции");
    },
    getReceipt() {
      axios
        .get(
          `${process.env.VUE_APP_AXIOS}/booking/pay/${this.$store.state.more.data.paymentid}`
        )
        .then((res) => {
          this.receipt = res.data;
        });
    },
    downloadReceipt() {
      html2canvas(document.querySelector("#receipt")).then((canvas) => {
        document.body.appendChild(canvas);
      });

      setTimeout(() => {
        let canvas = document.getElementsByTagName("canvas")[0];
        let image = canvas
          .toDataURL("image/png", 1.0)
          .replace("image/png", "image/octet-stream");
        let link = document.createElement("a");
        link.download = this.receipt.id + ".png";
        link.href = image;
        link.click();
      }, 1500);
    },
    closeDialog() {
      this.$store.state.more.active = false;
      let canvas = document.getElementsByTagName("canvas")[0];
      canvas.remove();

      this.receipt = "";
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.container.about {
  background: #f1f1f1;
  max-width: 1100px !important;
  margin: 75px auto 0 auto !important;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  display: flex;

  > * {
    width: 50%;

    &:last-child {
      padding-left: 20px;
    }
  }
}

.container.about .left > * {
  margin-bottom: 15px;
}

.container.about .left hr {
  margin: 20px 0;
}

.container.about .right .wrap {
  background-color: #ddd;
  position: relative;
  &::after {
    background: linear-gradient(-45deg, #f1f1f1 16px, transparent 0),
      linear-gradient(45deg, #f1f1f1 16px, transparent 0);
    background-position: left-bottom;
    background-repeat: repeat-x;
    background-size: 32px 32px;
    content: " ";
    display: block;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 32px;
  }

  .head {
    padding: 20px;
    background-color: royalblue;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
    }

    p {
      font-size: 14px;
      font-weight: 300;
      color: #fff;
      margin: 0;
    }
  }

  .body {
    margin-top: 15px;
    padding: 20px;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        padding-bottom: 5px;
        border-bottom: 1px dashed #2a2a2a;
        span {
          font-size: 14px;
        }
      }
    }
  }

  .footer {
    margin-top: 10px;
    padding: 20px 20px 45px 20px;
    border-top: 1px solid #ccc;

    .total {
      display: flex;
      justify-content: space-between;
      font-weight: 18px;

      span {
        font-weight: 500;
      }
    }

    p {
      margin-top: 25px;
      text-align: center;
      font-size: 12px;
    }
  }
}
</style>